export const scrollToEmitButton = () => {
  setTimeout(() => {
    const emitButton = document.querySelector(
      '[data-testid="emit-button"], .emit-button, button[type="submit"]'
    );
    if (emitButton) {
      emitButton.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    } else {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }
  }, 100);
};
